/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BoundingBox,
  BoundingBoxParams,
  HorizonAttributeComputingInfo,
  HorizonRequest,
  SurveyType,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class HorizonClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Horizon
   * @summary Получить идентификаторы интерпретаций для горизонтов
   * @request POST:/bff/Horizon/project/{projectId}/InterpretationIdsByHorizons
   * @secure
   */
  horizonGetInterpretationIdsByHorizonId = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<BoundingBoxParams, any>({
      path: `/bff/Horizon/project/${projectId}/InterpretationIdsByHorizons`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Horizon
   * @summary Получить ограничивающий прямоугольник для массива горизонтов
   * @request POST:/bff/Horizon/bounding-box
   * @secure
   */
  horizonCalcBoundingBox = (data: BoundingBoxParams, params: RequestParams = {}) =>
    this.http.request<BoundingBox, any>({
      path: `/bff/Horizon/bounding-box`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Horizon
   * @summary Создание горизонта
   * @request POST:/bff/Horizon/project/{projectId}/create-empty-horizon
   * @secure
   */
  horizonAddEmptyHorizon = (projectId: string, data: HorizonRequest, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/bff/Horizon/project/${projectId}/create-empty-horizon`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags Horizon
 * @summary Создание интерпретации горизонта
Создание пустого файла горизонта
 * @request POST:/bff/Horizon/project/{projectId}/create-empty-interpretation
 * @secure
 */
  horizonAddHorizonInterpretation = (
    projectId: string,
    query: {
      /**
       * Идентификатор горизонта
       * @format uuid
       */
      horizonId: string
      /**
       * Идентификатор съемки
       * @format uuid
       */
      surveyId: string
      /** Тип съемки */
      surveyType: SurveyType
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/bff/Horizon/project/${projectId}/create-empty-interpretation`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Horizon
   * @summary Расчет атрибута горизонта
   * @request POST:/bff/Horizon/horizon-attribute-computing
   * @secure
   */
  horizonCalcHorizonAttribute = (data: HorizonAttributeComputingInfo, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/bff/Horizon/horizon-attribute-computing`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
